
	
	import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../../../common/navbar';
import { RecruiterApi } from '../../../supports/recruiterApi';
import Loader from "../../../common/loader";
import BroadbeanModal from './broadBeanModal';
import Breadcrumb from './breadCrumb';
import MatchingCandidatesPage from '../matchingCandidates/matchingCandidatesPage';
import unifiedAuthManager from '../../../services/unifiedAuthManager';
import CandidateDetailPage from '../candidates/candidateDetailPage';
import CreateJobPage from '../createJobs/createJobPage';
import JobDataDetailed from './jobDataDetailed';
import { generateRequestId } from '../../../common/common';
import { useSelector } from "react-redux";
import { resumeUpload } from '../../../supports/resumeUpload';
import { useDispatch } from 'react-redux';
import { setSmartMatchJobDetails,setSmartMatchResults } from '../../../redux/smartMatchSlice';

const JobDetailPage = () => {
  const user = unifiedAuthManager.getUnifiedUser();
  const recruiterId = user?.id;
  const { jobId: jobIdParam } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [jobId, setJobId] = useState(null);
  const [mph_job_id, setMphJobId] = useState(jobIdParam);
  const [jobDetails, setJobDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [otherJobs, setOtherJobs] = useState([]);
  const [loadingOtherJobs, setLoadingOtherJobs] = useState(false);
  const [otherJobsError, setOtherJobsError] = useState(null);
  const [otherJobsPage, setOtherJobsPage] = useState(0);
  const [otherJobsHasMore, setOtherJobsHasMore] = useState(true);
  const [otherJobsTotal, setOtherJobsTotal] = useState(null);
  const [showBroadbeanModal, setShowBroadbeanModal] = useState(false);
  const [broadbeanDescription, setBroadbeanDescription] = useState('');
  const [savingBroadbean, setSavingBroadbean] = useState(false);
  const [broadbeanError, setBroadbeanError] = useState('');
  const otherJobsFetchedRef = useRef(false);
  
  // const [showMatchingCandidates, setShowMatchingCandidates] = useState(false);
  const [showMatchingFirstTime, setShowMatchingFirstTime] = useState(false); // used for isFirst
  // const [matchingCandidates, setMatchingCandidates] = useState([]);
  // const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [candidateActiveTab, setCandidateActiveTab] = useState('New');
  const [activeTab, setActiveTab] = useState('specification');
  const [smartMatchLoading, setSmartMatchLoading] = useState(false);
  const [smartMatchError, setSmartMatchError] = useState(null);
  const {
    searchTerm,
    statusValues,
    startDate,
    endDate,
    activeTabJobsPage
  } = useSelector((state) => state.searchFilters);
  const search = searchTerm ? `?q=${encodeURIComponent(searchTerm)}` : '';
  const smartMatchControllerRef = useRef(null);
  const fetchOtherJobsInProgressRef = useRef(false);
  const lastOtherJobsFetchKeyRef = useRef(null);
  const [candidateBreadcrumbName, setCandidateBreadcrumbName] = useState('');
  const [applicants, setApplicants] = useState([]);
  const [loadingApplicants, setLoadingApplicants] = useState(false);
  const [applicantsError, setApplicantsError] = useState(null);
  const [showEnhanceDescription, setShowEnhanceDescription] = useState(false);
  const [enhancedDescription, setEnhancedDescription] = useState(null);
  const dispatch = useDispatch();
  let breadcrumbs = location.pathname.includes('/dashboard')
    ? [
      { name: 'Home', path: `/dashboard/${search}` },
      { name: jobDetails?.title || 'Job Details', path: `/dashboard/jobDetails/${mph_job_id}` }
    ]
    : [
      { name: 'All Jobs', path: `/jobs` },
      { name: jobDetails?.title || 'Job Details', path: `/jobs/jobDetails/${mph_job_id}` }
    ];
  let matchingBreadcrumbs = [...breadcrumbs];
  if (jobDetails) {
    matchingBreadcrumbs.push({
      name: 'Matching Candidates',
      path: '__show_matching_candidates__'
    });
  }
  let candidateDetailBreadcrumbs = [...matchingBreadcrumbs];
  // if (selectedCandidate) {
  //   candidateDetailBreadcrumbs.push({
  //     name: candidateBreadcrumbName || `${selectedCandidate.first_name} ${selectedCandidate.last_name}`,
  //     path: null
  //   });
  // }
  const lastFetchedJobIdRef = useRef(null);
  const lastFetchPromiseRef = useRef(null);
  
  const fetchJobDetailsInProgressRef = useRef(false);

  const roles = JSON.parse(localStorage.getItem("unified_auth_user_roles"));
  var broadBeanUser = false;
  if (roles.includes("ROLE_BROADBEAN")) {
    broadBeanUser = true;
  }

  const fetchJobDetails = useCallback(async (id, forceRefresh = false) => {
    if (!forceRefresh && lastFetchedJobIdRef.current === id && lastFetchPromiseRef.current) {
      return lastFetchPromiseRef.current;
    }
    if (fetchJobDetailsInProgressRef.current && !forceRefresh) {
      return lastFetchPromiseRef.current;
    }
    setLoading(true);
    fetchJobDetailsInProgressRef.current = true;
    const fetchPromise = (async () => {
      try {
        const response = await RecruiterApi.getJobDetails({
          job_id: id,
          user_payload: { request_id: generateRequestId() },
          email: user.email
        });
        if (response.success) {
          setJobDetails(response.data);
          setJobId(response.data.id);
          setMphJobId(response.data.mph_jobid);
          setEnhancedDescription(null);
        } else {
          setJobDetails(null);
          setEnhancedDescription(null);
        }
      } catch (error) {
        console.error('Error fetching job details:', error);
        setJobDetails(null);
        setEnhancedDescription(null);
      } finally {
        setLoading(false);
        fetchJobDetailsInProgressRef.current = false;
      }
    })();
    lastFetchedJobIdRef.current = id;
    lastFetchPromiseRef.current = fetchPromise;
    return fetchPromise;
  }, [user?.email]);

  const refreshJobDetails = async (id, forceRefresh = false) => {
    setLoading(true);
    fetchJobDetailsInProgressRef.current = true;
    const fetchPromise = (async () => {
      try {
        const response = await RecruiterApi.getJobDetails({
          job_id: id,
          user_payload: { request_id: generateRequestId() },
          email: user.email
        });
        if (response.success) {
          setJobDetails(response.data);
          setJobId(response.data.id);
          setMphJobId(response.data.mph_jobid);
          setEnhancedDescription(null);
        } else {
          setJobDetails(null);
          setEnhancedDescription(null);
        }
      } catch (error) {
        console.error('Error fetching job details:', error);
        setJobDetails(null);
        setEnhancedDescription(null);
      } finally {
        setLoading(false);
        fetchJobDetailsInProgressRef.current = false;
      }
    })();
    lastFetchedJobIdRef.current = id;
    lastFetchPromiseRef.current = fetchPromise;
    return fetchPromise;
  };

  const fetchApplicants = useCallback(async (jobId) => {
    if (!jobId) return;
    setLoadingApplicants(true);
    setApplicantsError(null);
    try {
      const response = await RecruiterApi.getJobApplicants({
        job_id: jobId,
        user_payload: {
          request_id: generateRequestId(),
          email: user.email,
          tenant: 'tenant'
        },
      });
      if (response.success && response.data) {
        setApplicants(response.data.value);
      } else {
        setApplicants([]);
        setApplicantsError('No applicants found.');
      }
    } catch (error) {
      setApplicants([]);
      setApplicantsError('Failed to load applicants.');
      console.error('Error fetching applicants:', error);
    } finally {
      setLoadingApplicants(false);
    }
  }, [user?.email]);

  const PAGE_SIZE = 10;

  const fetchOtherJobs = useCallback(
    async (page = 0, append = false) => {
      const filterKey = JSON.stringify({
        searchTerm: searchTerm || "",
        statusValues: statusValues || [],
        startDate: startDate || "",
        endDate: endDate || "",
        activeTab: activeTab || "All Jobs",
      });

      const fetchKey = `${filterKey}_${page}`;

      if (
        fetchOtherJobsInProgressRef.current &&
        lastOtherJobsFetchKeyRef.current === fetchKey
      ) {
        return;
      }

      fetchOtherJobsInProgressRef.current = true;
      lastOtherJobsFetchKeyRef.current = fetchKey;

      setLoadingOtherJobs(true);
      setOtherJobsError(null);

      const hasFilters =
        (searchTerm && searchTerm.trim() !== "") ||
        (Array.isArray(statusValues) && statusValues.length > 0) ||
        startDate ||
        endDate;

      //
      // CASE 1 — FILTERS EXIST → ALWAYS CALL SEARCH API
      //
      if (hasFilters) {
        try {
          const body = {
            user_payload: { request_id: generateRequestId() },
          };

          if (searchTerm) body.search_text = searchTerm.trim();
          if (statusValues.length > 0) body.job_status = statusValues;
          if (startDate) body.start_date = startDate;
          if (endDate) body.end_date = endDate;

          const response = await RecruiterApi.getJobsBySearch(body);

          const jobs = Array.isArray(response?.data?.job_descriptions)
            ? response.data.job_descriptions
            : [];

          const total = response?.data?.total_count || null;

          if (response.success) {
            setOtherJobs((prev) => (append ? [...prev, ...jobs] : jobs));
            setOtherJobsHasMore(jobs.length === PAGE_SIZE);
            setOtherJobsPage(page);
            setOtherJobsTotal(total);
          } else {
            setOtherJobs([]);
            setOtherJobsHasMore(false);
            setOtherJobsError("Failed to load jobs list.");
          }
        } catch (error) {
          console.error("Search error:", error);
          setOtherJobs([]);
          setOtherJobsHasMore(false);
          setOtherJobsError("Failed to load jobs list.");
        } finally {
          setLoadingOtherJobs(false);
          fetchOtherJobsInProgressRef.current = false;
        }

        return;
      }

      //
      // CASE 2 — NO FILTERS → CALL API BASED ON TAB
      //
      try {
        if (activeTabJobsPage === "All Jobs") {
          // 🔹 Fetch all jobs API
          const response = await resumeUpload.fetchAlljobs({
            recruiter_id: recruiterId,
            user_payload: { request_id: generateRequestId() },
            page: page + 1,
            limit: PAGE_SIZE,
          });

          const jobs = response?.data?.jobs || [];
          const total = response?.data?.total_jobs || null;

          setOtherJobs((prev) => (append ? [...prev, ...jobs] : jobs));
          setOtherJobsHasMore(response?.data?.have_more ?? jobs.length === PAGE_SIZE);
          setOtherJobsPage(page);
          setOtherJobsTotal(total);
        } else {
          // 🔹 Fetch My Position API
          const requestBody = {
            recruiter_id: recruiterId,
            user_payload: { request_id: generateRequestId() },
            count: PAGE_SIZE,
            page,
          };

          const response = await RecruiterApi.getJobsList(requestBody);

          const jobs = response?.data?.jobs || [];
          const total = response?.data?.total_count || null;

          setOtherJobs((prev) => (append ? [...prev, ...jobs] : jobs));
          setOtherJobsHasMore(jobs.length === PAGE_SIZE);
          setOtherJobsPage(page);
          setOtherJobsTotal(total);
        }
      } catch (error) {
        console.error("Tab-based fetch error:", error);
        setOtherJobs([]);
        setOtherJobsHasMore(false);
        setOtherJobsError("Failed to load jobs list.");
      } finally {
        setLoadingOtherJobs(false);
        fetchOtherJobsInProgressRef.current = false;
      }
    },
    [recruiterId, searchTerm, statusValues, startDate, endDate, activeTab]
  );

  useEffect(() => {
    otherJobsFetchedRef.current = false;
    setOtherJobs([]);
    setOtherJobsPage(0);
    setOtherJobsHasMore(true);
    setOtherJobsError(null);
    setOtherJobsTotal(null);
    if (!otherJobsFetchedRef.current) {
      otherJobsFetchedRef.current = true;
      fetchOtherJobs(0, false);
    }
  }, [searchTerm]);

  // Fetch job details
  useEffect(() => {
    if (mph_job_id && lastFetchedJobIdRef.current !== mph_job_id) {
      fetchJobDetails(mph_job_id);
    }
  }, [mph_job_id, fetchJobDetails]);

  useEffect(() => {
    if (activeTab === 'applicants' && jobDetails?.mph_job_gid) {
      fetchApplicants(jobDetails.mph_job_gid);
    }
  }, [activeTab, fetchApplicants, jobDetails?.mph_job_gid]);

  const sidebarRef = useRef(null);

  useEffect(() => {
    const sidebar = sidebarRef.current;
    if (!sidebar) return;

    const handleScroll = () => {
      if (
        sidebar.scrollTop + sidebar.clientHeight >= sidebar.scrollHeight - 40 &&
        otherJobsHasMore &&
        !loadingOtherJobs
      ) {
        fetchOtherJobs(otherJobsPage + 1, true);
      }
    };

    sidebar.addEventListener('scroll', handleScroll);
    return () => {
      sidebar.removeEventListener('scroll', handleScroll);
    };
  }, [otherJobsHasMore, loadingOtherJobs, fetchOtherJobs, otherJobsPage]);

  const handleBreadcrumbClick = (path) => {
    if (path === '__show_matching_candidates__') {
      // setShowMatchingCandidates(true);
      setShowMatchingFirstTime(true); // mark as coming from breadcrumbs (list)
      // setSelectedCandidate(null);
      setActiveTab('specification');
      return;
    }
    if (path) {
      // setShowMatchingCandidates(false);
      setShowMatchingFirstTime(false);
      // setSelectedCandidate(null);
      setActiveTab('specification');
      navigate(path);
    }
  };

  const handleOpenBroadbeanModal = async () => {
    setShowBroadbeanModal(true);
    try {
      setBroadbeanDescription(jobDetails.complete_job_description);
    } catch (err) {
      console.error("Broadbean fetch error:", err);
    }
  };

  const handleSaveBroadbeanDescription = (updatedHtml) => {
    setSavingBroadbean(true);
    setJobDetails(prev => ({ ...prev, crm_job_description: updatedHtml }));
    setShowBroadbeanModal(false);
    setSavingBroadbean(false);
    setBroadbeanDescription('');
    setBroadbeanError('');
  };

  const handleCloseBroadbeanModal = () => {
    setShowBroadbeanModal(false);
    setBroadbeanDescription('');
    setBroadbeanError('');
  };

  const handleOtherJobClick = (job) => {
    // setShowMatchingCandidates(false);
    setShowMatchingFirstTime(false);
    // setSelectedCandidate(null);
    setActiveTab('specification');
    setJobId(job.id);
    setMphJobId(job.mph_jobid);
  };

const handleSmartMatchClick = async () => {
  if (smartMatchControllerRef.current) {
    smartMatchControllerRef.current.abort();
  }
  const controller = new AbortController();
  smartMatchControllerRef.current = controller;

  setSmartMatchLoading(true);
  setSmartMatchError(null);

  try {
    // 1. Define the hardcoded data

   const response = await RecruiterApi.getSmartMatchCandidates({
        user_payload: {
          request_id: generateRequestId(),
          email: user.email,
          tenant: "",
          user_id: user.id
        },
        payload: {
          job_id: jobDetails.id
        },
      }, { signal: controller.signal });
    
    if (response.success) {
           dispatch(setSmartMatchResults(response.data.hits));
        dispatch(setSmartMatchJobDetails(jobDetails))
        // 3. Navigate to the new route
        navigate(`/jobs/jobDetails/smartmatch/${mph_job_id}`);
      // setMatchingCandidates(response.data.hits);
      // setShowMatchingCandidates(true);
      // setSelectedCandidate(null);
      setCandidateActiveTab(null);
        // setMatchingCandidates(response.data.hits)
        // setShowMatchingCandidates(true);
        setShowMatchingFirstTime(false); // coming from smartmatch, so not first time in matchinglist via list
        // setSelectedCandidate(null);
    } else {
      setSmartMatchError('Failed to fetch smart match candidates.');
    }
  } catch (error) {
    if (error.name === 'AbortError' || error.message === 'Aborted') {
      console.log('Fetch aborted');
    } else {
      setSmartMatchError('Failed to fetch smart match candidates.');
      console.error('Error fetching smart match candidates:', error);
    }
  } finally {
    setSmartMatchLoading(false);
    smartMatchControllerRef.current = null;
  }
};

  useEffect(() => {
    return () => {
      if (smartMatchControllerRef.current) {
        smartMatchControllerRef.current.abort();
      }
    };
  }, []);

  // const handleCandidateSelect = (candidate, activeTab) => {
  //   setSelectedCandidate(candidate);
  //   setCandidateActiveTab(activeTab);
  //   if (candidate) {
  //     setCandidateBreadcrumbName(`${candidate.first_name} ${candidate.last_name}`);
  //   } else {
  //     setCandidateBreadcrumbName('');
  //   }
  // };
  // const updateCandidate = (updatedCandidate) => {
  //   try {
  //     if (!updatedCandidate || !updatedCandidate.id) {
  //       return;
  //     }
  //     setMatchingCandidates(prev =>
  //       prev.map(candidate =>
  //         candidate.id === updatedCandidate.id ? updatedCandidate : candidate
  //       )
  //     );
  //   } catch (error) {
  //     console.error("Error updating candidate:", error);
  //   }
  // };

  // const handleCloseCandidateDetail = () => {
  //   setSelectedCandidate(null);
  //   setCandidateBreadcrumbName('');
  //   setShowMatchingFirstTime(true); // when returning to matching list from detail, isFirst should be 1
  // };

  // const handleViewAllMatchingCandidates = (show) => {
  //   if (show) {
  //     setShowMatchingCandidates(true);
  //     setShowMatchingFirstTime(true); // force isFirst=1 when viewing list again
  //     setSelectedCandidate(null);
  //     setCandidateBreadcrumbName('');
  //   }
  // };

  // const handleCandidateChange = (candidate) => {
  //   setSelectedCandidate(candidate);
  //   if (candidate) {
  //     setCandidateBreadcrumbName(`${candidate.first_name} ${candidate.last_name}`);
  //   } else {
  //     setCandidateBreadcrumbName('');
  //   }
  // };

  // === Enhancement handlers ===
  const handleEnhanceDescriptionClick = () => {
    setShowEnhanceDescription(true);
  };

  const handleEnhanceDescriptionSave = (newDescription) => {
    setEnhancedDescription(newDescription);
    setShowEnhanceDescription(false);
  };

  const handleEnhanceDescriptionCancel = () => {
    setShowEnhanceDescription(false);
  };

  if (loading) {
    return (
      <div className="min-h-screen main-background flex flex-col">
        <Navbar />
        <div className="flex-1 flex items-center justify-center">
          <Loader message="Loading job details" />
        </div>
      </div>
    );
  }

  if (!jobDetails) {
    return (
      <div className="min-h-screen main-background">
        <Navbar />
        <main className="w-full  flex justify-center items-center pt-40 text-gray-999 text-sm">
         No job information is available for the specified job ID
        </main>
      </div>
    );
  }


  if (showEnhanceDescription) {
    return (
      <div className="min-h-screen bg-white relative main-background">
        <Navbar />
        <main className="w-full px-4 overflow-y-auto">
          <div className="mx-auto px-3 pb-8">
            <div className="mx-auto">
              <CreateJobPage
                initialDescription={enhancedDescription ?? jobDetails.complete_job_description ?? ''}
                onSave={handleEnhanceDescriptionSave}
                onCancel={handleEnhanceDescriptionCancel}
              />
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white relative main-background">
      <Navbar />

      <main className="w-full px-4 py-[6rem] overflow-hidden anim-slideUp">
        <Breadcrumb items={breadcrumbs} onClick={handleBreadcrumbClick} />
        <JobDataDetailed
          jobDetails={jobDetails}
          activeTab={activeTab}
          applicants={applicants}
          loadingApplicants={loadingApplicants}
          applicantsError={applicantsError}
          otherJobs={otherJobs}
          loadingOtherJobs={loadingOtherJobs}
          otherJobsError={otherJobsError}
          enhancedDescription={enhancedDescription}
          setActiveTab={setActiveTab}
          handleSmartMatchClick={handleSmartMatchClick}
          handleOpenBroadbeanModal={handleOpenBroadbeanModal}
          handleEnhanceDescriptionClick={handleEnhanceDescriptionClick}
          handleOtherJobClick={handleOtherJobClick}
          smartMatchLoading={smartMatchLoading}
          smartMatchError={smartMatchError}
          broadBeanUser={broadBeanUser}
          onRefreshJobDetails={refreshJobDetails}
        />
      </main>

      {/* === Broadbean Modal === */}
      {showBroadbeanModal && (
        <BroadbeanModal
          mph_job_id={mph_job_id}
          jobDetails={jobDetails}
          email={user.email}
          description={broadbeanDescription}
          onClose={handleCloseBroadbeanModal}
          onSave={handleSaveBroadbeanDescription}
          isSaving={savingBroadbean}
          error={broadbeanError}
        />
      )}
    </div>
  );
};

export default JobDetailPage;